var App = require('app');
var FilterDialogView = require('components/devices/views/common/filter_dialog_view');

module.exports = Marionette.Object.extend({
    showFilterDialog: function (srcFilter, cb, fixedCategory, fixedStatus, hideFilterButton) {
        App.showModal(
            new FilterDialogView({
                filter: srcFilter,
                fixedCategory: fixedCategory,
                fixedStatus: fixedStatus,
                cb: function (filter) {
                    cb && cb(filter);
                },
            })
        );
    },
});
